import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateServer'
})

export class DateServerPipe implements PipeTransform {
  
  transform(value: any, formato: string): string
  {
    let fecha = moment(value);
    let fechaFormateada = fecha.format(formato);
    
    return fechaFormateada;
  }
}
